import React from "react";
import { useQuery } from "@tanstack/react-query";
// import { useNavigate } from "react-router-dom"; 
import authAxios from "./authAxios";
import { useNavigate } from "react-router-dom";

import { Typography, Space } from "antd";
import { Card } from "antd";

import { Button } from "antd";
import { RightOutlined } from "@ant-design/icons";

import DashboardHeader from "./DashboardHeader";

import {
  FileTextOutlined,
  BarChartOutlined,
  DollarOutlined,
  CalendarOutlined,
  ToolOutlined,
  PercentageOutlined,
  CalculatorOutlined,
  FireOutlined,
  ShoppingOutlined,
  DropOutlined,
} from "@ant-design/icons";

const ICON_MAP = {
  "bar-chart":   BarChartOutlined,
  "file-text":   FileTextOutlined,
  "calendar":    CalendarOutlined,
  "percentage":  PercentageOutlined,
  "calculator":  CalculatorOutlined,
  "tool":        ToolOutlined,
  "shopping":    ShoppingOutlined,
  // "home":        HomeOutlined,
  "dollar":      DollarOutlined,
  // "receipt":     FileOutlined,
  // fallback
  "report":      FileTextOutlined,
};

export const ReportIcon = ({ name, ...props }) => {
  const Icon = ICON_MAP[name] ?? ICON_MAP["report"];
  return <Icon {...props} />;
};



const ReportsLibrary = () => {
  const navigate = useNavigate();


  const { Title, Text } = Typography;


  const { data: reportsData = [], isLoading } = useQuery({
    queryKey: ["reports-library"],
    queryFn: async () => {
      const response = await authAxios.get("/reports/library/");
      return response.data;
    },
  });


  return(
    <div className="dashboard-main">
        <section className="dashboard-content">
        <DashboardHeader dashboardTitle="Reports Library" dashboardPreTitle="Reports" />

        <div style={{ marginTop: 24, display: "flex", gap: 40, flexWrap: "wrap" }}>
            {/* {reportsData.map((category) => (
            <Card
                // key={category.title}
                // title={category.title}
                key={category.code}
                title={category.name.toUpperCase()}
                bordered={false}
                style={{ flex: "1 1 250px", backgroundColor: "transparent" }}
                bodyStyle={{ padding: "0 24px" }}
            >
                <Space direction="vertical">
                {category.items.map((item) => (
                <Button 
                    type="text" 
                    key={item.label}
                    // style={{ display: "flex", alignItems: "center", padding: 0, height: "auto" , lineHeight: "1.6" }}
                    style={{ display: "flex", alignItems: "center", padding: 0, height: "auto", fontSize: "13.5px"  }}
                    icon={item.icon}
                >
                    {item.label}
                </Button>
                ))}
                </Space>
            </Card>
            ))} */}
            {reportsData.map((category) => (

            <Card
              key={category.code}
              title={category.name.toUpperCase()}
              bordered={false}
              style={{ flex: "1 1 250px", backgroundColor: "transparent" }}
              bodyStyle={{ padding: "0 24px" }}
            >
              <Space direction="vertical">
                {category.reports.map((report) => (
                  <Button
                    type="text"
                    key={report.code}
                    // icon={getReportIcon(report.icon)}
                    icon={<ReportIcon name={report.icon} />}
                    onClick={() => navigate(report.path)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: 0,
                      height: "auto",
                      // fontSize: "13.5px",
                      fontSize: "0.85rem",

                    }}
                  >
                    {report.display_name}
                  </Button>
                ))}
              </Space>
            </Card>
          ))}
        </div>
        </section>
    </div>
  );
};
export default ReportsLibrary;